import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Alert,
} from '@mui/material';
import axios from 'axios';

export default function Withdrawals({ user }) {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate amount
    const numericAmount = Number(amount);
    if (numericAmount < 100) {
      setError('Amount must be at least $100');
      return;
    }
    if (numericAmount > 100000) {
      setError('Amount cannot exceed $100,000');
      return;
    }

    // Only owner can withdraw
    if (user?.role !== 'owner') {
      setError('Only owner can initiate withdrawals');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        '/api/withdraw',
        { amount: numericAmount, userId: user.id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (err) {
      setError('Withdrawal failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Withdraw Funds
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            type="number"
            label="Amount ($)"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            inputProps={{ min: 100, max: 100000 }}
            fullWidth
            margin="normal"
            placeholder="Enter amount (min $100)"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading || user?.role !== 'owner'}
            fullWidth
          >
            {loading ? 'Processing...' : 'Withdraw'}
          </Button>
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </form>
      </CardContent>
    </Card>
  );
}
